<template>
  <div>
    <!-- sync status -->
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          :color="telemetry.has_sync_error ? 'red' : 'green'"
          dark
          v-bind="attrs"
          v-on="on"
        >
          mdi-sync
        </v-icon>
      </template>
      <span>App Sync Status</span>
    </v-tooltip>

    <!-- startup status -->
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          :color="telemetry.has_startup_error ? 'red' : 'green'"
          dark
          v-bind="attrs"
          v-on="on"
        >
          mdi-shoe-sneaker
        </v-icon>
      </template>
      <span>App Boot Status</span>
    </v-tooltip>

    <!-- telemetry details -->
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          color="blue"
          dark
          v-bind="attrs"
          v-on="on"
          @click="configDialog(telemetry)"
        >
          mdi-alpha-i-box
        </v-icon>
      </template>
      <span>Click for details</span>
    </v-tooltip>

    <!-- dialog to show telemtry details -->
    <v-dialog v-if="dialog.telemetry" v-model="dialog.show" width="auto">
      <v-card>
        <v-card-title class="text-h4 green darken-2 white--text">
          Telemtry Info
        </v-card-title>

        <v-row>
          <v-col md="3">
            <v-card-text>
              <v-list flat>
                <!-- Hardware/Process -->
                <v-list-item-group color="indigo">

                  <!-- telemetry timestamp -->
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon color="grey">mdi-archive-clock</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                    <v-list-item-title>Telemetry Timestamp</v-list-item-title>
                      {{ setDate(dialog.telemetry.created_at) }}
                    </v-list-item-content>
                  </v-list-item>

                  <!-- bluetooth -->
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon color="blue">mdi-bluetooth</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>Bluetooth</v-list-item-title>
                      {{ dialog.telemetry.payload.bluetooth_state }}
                    </v-list-item-content>
                  </v-list-item>

                  <!-- mode -->
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon color="green">mdi-chip</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>Hardware Mode</v-list-item-title>
                      {{ dialog.telemetry.payload.hardware_mode }}
                    </v-list-item-content>
                  </v-list-item>

                  <!-- uptime -->
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon color="gray">mdi-clock-time-three</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                      <v-list-item-title>Uptime</v-list-item-title>
                      {{ dialog.telemetry.payload.processAge }}
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>

                <!-- Square -->
                <v-list-item-group color="indigo">
                  <!-- state -->
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon color="indigo">mdi-crop-square</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                      <v-list-item-title>Square State</v-list-item-title>
                      {{ dialog.telemetry.payload.squareSDKManager.state }}
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>

                <!-- Star -->
                <v-list-item-group color="indigo">
                  <!-- state -->
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon color="orange">mdi-star-face</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                      <v-list-item-title>StarIO State</v-list-item-title>
                      {{ dialog.telemetry.payload.starIO.status }}
                    </v-list-item-content>
                  </v-list-item>

                  <!--  barcode scanner -->
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon color="black">mdi-barcode</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                      <v-list-item-title
                        >StarIO Barcode Scanner Status</v-list-item-title
                      >
                      {{ dialog.telemetry.payload.starIO.barcodeScannerStatus }}
                    </v-list-item-content>
                  </v-list-item>

                  <!-- printer -->
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon color="gray">mdi-printer</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                      <v-list-item-title
                        >StarIO Printer Status</v-list-item-title
                      >
                      {{ dialog.telemetry.payload.starIO.printerPaperStatus }}
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card-text>
          </v-col>
          <!-- json dump -->
          <v-col md="9">
            <v-card-title class="text-h6 gray black--text">
              Json Dump
            </v-card-title>
            <pre>{{ dialog.telemetry }}</pre>
          </v-col>
        </v-row>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog.show = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    telemetry: {
      required: true,
      type: Object,
    },
    register: {
      required: true,
      type: Object,
    },
  },
  data: () => ({
    dialog: {
      telemetry: null,
      show: false,
    },
  }),
  mounted() {
  },
  methods: {
    configDialog(telemetry) {
      this.dialog.telemetry = telemetry;
      this.dialog.show = true;
    },
    setDate(date) {
      return new Date(date).toString();
    }
  },
};
</script>
